import { SDUISearchDropdownEmptyState } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/SearchDropdown/SDUISearchDropdownEmptyState";
import { ResultsDropdown } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultsDropdown";
import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web/slate/Color";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import { useEffect, useRef } from "react";
import styled from "styled-components";

const RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP = getSpacing("1x");

export const ResultsDropdownWrapper = ({
  displaySDUIEmptyState,
  parent,
  searchElement,
  submit,
  cancelSearch,
  query,
  dontShowSearch,
  shouldEnableSuggestionsImpressionAllocationV2,
  ...rest
}: {
  displaySDUIEmptyState: boolean;
  parent: HTMLDivElement | null;
  searchElement?: HTMLElement | null;
  submit: (query: string, submittedUrl?: string, navigate?: boolean) => void;
  cancelSearch: () => void;
  query: string;
  dontShowSearch: () => void;
  shouldEnableSuggestionsImpressionAllocationV2: boolean;
}) => {
  const dropdownContainerRef = useRef<HTMLDivElement>(null);
  const parentRect = useRef(parent ? parent.getBoundingClientRect() : null);

  useEffect(() => {
    parentRect.current = parent ? parent.getBoundingClientRect() : null;
  }, [parent]);

  const viewProps: {
    $top: number;
    $width?: number;
  } = {
    $top: 60,
    $width: 500,
  };

  if (parentRect && parentRect.current) {
    viewProps.$top = parentRect.current.height + 22;
    viewProps.$width = parentRect.current.width;
  }
  return (
    <ResultsDropdownWrapperStyled
      {...viewProps}
      ref={dropdownContainerRef}
      {...rest}
    >
      {displaySDUIEmptyState ? (
        <SDUISearchDropdownEmptyState submit={submit} />
      ) : (
        <ResultsDropdown
          parent={parent}
          searchElement={searchElement}
          submit={submit}
          cancelSearch={cancelSearch}
          query={query}
          dontShowSearch={dontShowSearch}
          shouldEnableSuggestionsImpressionAllocationV2={
            shouldEnableSuggestionsImpressionAllocationV2
          }
        />
      )}
    </ResultsDropdownWrapperStyled>
  );
};

export const ResultsDropdownWrapperStyled = styled.div<{
  $top: number;
  $width?: number;
  $height?: number;
}>`
  max-height: 93vh;
  ${responsiveMediaQueries.mobile} {
    height: 100vh;
  }
  background: ${Core.surface.inverse};
  z-index: 500;
  ${TypographyStyles({ as: undefined })}

  position: absolute;
  top: ${(props) => props.$top}px;
  width: ${(props) => props.$width}px;

  overflow-y: auto;
  box-shadow: 0 1px 1px 0px ${Core.surface.subdued};
  border-radius: var(--radius-fs-component-default);

  h5 {
    margin: 4px 0 0 18px !important;
    ${TypographyStyles({ as: undefined })}
  }

  > div:first-of-type h5 {
    margin-top: 0;
  }

  strong {
    ${TypographyStyles({ truncate: true, variant: "paragraphSansMedium" })}
    min-width: 0;
  }

  span {
    ${TypographyStyles({ truncate: true })}
    min-width: 0;
  }

  > div:last-of-type {
    padding-top: ${RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP};
  }

  box-shadow: 0 7px 10px ${Core.surface.enabled + Opacity.O_10};

  @media screen and (max-width: 767px) {
    top: ${(props) => props.$height}px;
    left: 0;
    right: 0;
    width: auto;
    bottom: 0;
  }
`;
